import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21260 21812"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m10142 16805-5050-4584 5050-4625v9209zm9547-6748v4244h-8486v-4244h8486zm510 5305c297 0 552-255 552-552V9548c0-297-255-552-552-552h-8996V6408c0-212-127-382-298-467-212-85-424-43-551 85l-6365 5814c-212 212-212 593 0 763l6365 5814c170 127 382 169 551 85 213-85 298-255 298-467v-2673h8996z"
        className="fil0"
      />
      <path
        d="m2419 12221 5940-5431c213-212 213-552 43-764-212-212-552-212-764-42l-6365 5813c-212 212-212 594 0 764l6365 5813c212 212 552 170 764-42s170-552-43-764l-5940-5347zM3734 0c305 0 552 247 552 552 0 304-247 552-552 552-304-1-551-248-551-552 0-305 247-552 551-552zM9038 2674c305 0 552 247 552 551s-247 552-552 552c-304 0-551-247-551-552 0-304 247-551 551-551zM19647 3183c305 0 552 247 552 552 0 304-247 551-552 551-304 0-552-247-552-551 1-305 248-552 552-552zM15404 18586c304 0 551 248 551 552 0 305-247 552-551 552-305 0-552-247-552-552 0-304 247-552 552-552zM4795 20708c305 0 552 247 552 552s-247 552-552 552-552-247-552-552 247-552 552-552zM1655 16465c305 0 552 247 552 552 0 304-247 551-552 551s-552-247-552-551c0-305 247-552 552-552zM19393 19647c-425 0-807-339-807-806s340-806 807-806c466 0 806 339 806 806s-340 807-806 806zm0-2630c-1019 0-1868 849-1868 1867s849 1867 1868 1867c1018 0 1867-849 1867-1867s-849-1867-1867-1867zM14640 1612c721 0 1315 595 1315 1316 0 722-594 1315-1315 1315s-1315-593-1315-1315c0-721 594-1316 1315-1316zm0 3735c1315 0 2377-1061 2377-2376 0-1316-1062-2377-2377-2377s-2377 1061-2377 2377c0 1315 1062 2376 2377 2376zM1103 4286c0-297 254-551 552-551 297 0 552 254 552 551s-255 552-552 552-552-255-552-552zm2122 0c0-891-722-1612-1613-1612S0 3395 0 4286s721 1612 1612 1612 1613-763 1613-1612z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
